
import {
    FETCH_CURRENT_USER,
    UPDATE_CURRENT_USER,
    } from "../actions/types";





export default function rootReducer(state = {}, action) {
  // console.log({state,action})
  switch (action.type) {
    case FETCH_CURRENT_USER:
      return ({...action.currentUser});
    case UPDATE_CURRENT_USER:
      console.log({action})
      return ({...state, ...action.updated});
    default:
      return state;
};
};
